export default {"src":"/_next/static/media/logo.0ee768fa.svg","height":40,"width":194,"blurWidth":0,"blurHeight":0};